import React, { FC } from 'react';
import { Modal } from '../../../dialogs/useModal';
import { EditGuideFigure } from './EditGuideFigure';
import { Dialog } from '@mui/material';
import { FiguresContextProvider } from './FiguresContext';
import { ImageFigure } from './figureHelper';

export interface GuideFigureDialogResult {
  figure?: ImageFigure;
}

export interface GuideFigureDialogProps {
  editFigureId?: string;
  isNew: boolean;
}

export const GuideFigureDialog: FC<Modal<GuideFigureDialogProps, GuideFigureDialogResult>> = (modal) => {
  return (
    <FiguresContextProvider modal={modal}>
      <Dialog open={true} maxWidth="md" fullWidth={true} onClose={() => modal.close()}>
        <EditGuideFigure isNew={modal.data.isNew} />
      </Dialog>
    </FiguresContextProvider>
  );
};
